module.exports = __webpack_public_path__ + "static/media/happy.222f7235.jpg";